import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  outlineColor,
  subscriptionFormStyle,
  tacTextAndIconColor,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const SubscriptionFormStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //const { moduleType } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper
        title={getI18n('salesChannelContent.index.inputFieldOutlineColour')}>
        <Field name={[subscriptionFormStyle, outlineColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper
        title={getI18n(
          'salesChannelContent.index.termsConditionTextIconColour',
        )}>
        <Field name={[subscriptionFormStyle, tacTextAndIconColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default SubscriptionFormStyle;
